import { MutationTree } from 'vuex';
import { CateringBotState } from '../types';

export const mutations: MutationTree<CateringBotState> = {};
